import React from 'react';

import Problem from 'shared/ui/icons/General/Problem';

import {PALETTE} from 'shared/config/model/palette';

import {EMAIL_ERROR_DESCRIPTIONS, EmailErrorType} from '../../lib/email';

interface EmailProblemBlockProps {
    error: EmailErrorType | null;
}

const getErrorDescription = (error: EmailErrorType): string => {
    return EMAIL_ERROR_DESCRIPTIONS[error] || `Неизвестная ошибка: ${error}`;
};

const EmailProblemBlock: React.FC<EmailProblemBlockProps> = ({error}) => {
    if (error === null) {
        return <></>;
    }

    return (
        <span title={getErrorDescription(error)}>
            <Problem color={PALETTE.warningDark} />
        </span>
    );
};

export default  EmailProblemBlock;